import { gql } from '@apollo/client';
import PRODUCT from 'api/fragments/PRODUCT';
const ARCHIVE_PRODUCT = gql `
  ${PRODUCT}
  mutation ArchiveProduct($productId: ID!) {
    archiveProduct(productId: $productId) {
      product {
        ...ProductFragment
      }
    }
  }
`;
export default ARCHIVE_PRODUCT;
